if (!customElements.get(`free-gift`)) {
	class FreeGift extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.addDelegatedEventListeners();
		}

		addDelegatedEventListeners() {
			this.addEventListener(`click`, (e) => {
				const clicked_element = e.target.closest(`[data-action]`);
				if (!clicked_element) return;

				const { action, clickedTab } = clicked_element.dataset;


				switch (action) {
					case `switch-product`:
						const tabs = this.querySelectorAll(`[data-action="switch-product"]`);
						const gifts = this.querySelectorAll(`[data-gift-wrapper]`);

						tabs.forEach((tab) => {
							tab.classList.remove(`font-bold`, `underline`);
						});

						gifts.forEach((gift) => {
							const tab_value = gift.getAttribute(`data-tab`);
              const swiper = gift.querySelector(`swiper-carousel`);

							if (tab_value === clickedTab) {
								gift.classList.remove(`hidden`);
                swiper?.reinit();
							} else {
								gift.classList.add(`hidden`);
							}
						});

						clicked_element.classList.add(`font-bold`, `underline`);

						break;

					default:
						break;
				}
			});
		}
	}

	customElements.define(`free-gift`, FreeGift);
}
